<pp-modal>
  <ng-container heading>
    {{ 'Delete' | ppTranslate }}
    <strong>{{ tag.name }}</strong>
    {{ 'tag' | ppTranslate }}
  </ng-container>

  <ng-container body>
    <p [ngClass]="{ 'no-margin': !info }">
      {{ 'delete_warning' | ppTranslate }}
      <strong>{{ tag.name }}</strong>
      {{ 'tag' | ppTranslate }}?
    </p>

    @if (info) {
      <p class="no-margin">
        <strong>{{ tag.name }}</strong>
        {{ info }} {{ usersNumber > 0 ? ('tag_delete_warning' | ppTranslate) : '' }}
      </p>
    }
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'Delete' | ppTranslate"
      (ppCancel)="hideModal()"
      (ppConfirm)="deleteTag()"
      [ppProcess]="modal.processing"
      [ppError]="true"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
